import { Injectable } from '@angular/core';
import { jwtDecode } from 'jwt-decode';

@Injectable({
  providedIn: 'root'
})
export class JwtService {

  constructor() {}

  decodeToken(token: string): any {
    try {
      return jwtDecode(token);
    } catch (error) {
      return null;
    }
  }

  isTokenExpired(token: string): boolean {
    const decoded = this.decodeToken(token);
    if (!decoded) {
      return true;
    }

    const currentTime = Date.now() / 1000;
    return decoded.exp < currentTime;
  }

  getTokenExpirationDate(token: string): Date | null {
    const decoded = this.decodeToken(token);
    if (!decoded || !decoded.exp) {
      return null;
    }

    const date = new Date(0);
    date.setUTCSeconds(decoded.exp);
    return date;
  }

  getRemainingTime(token: string): number {
    const expDate = this.getTokenExpirationDate(token);
    if (!expDate) {
      return 0;
    }
    
    return expDate.getTime() - Date.now();
  }

  getTokenPayload(token: string): any {
    const decoded = this.decodeToken(token);
    if (!decoded) {
      return null;
    }
    
    // Remove standard JWT claims
    const { iat, exp, nbf, iss, aud, sub, jti, ...payload } = decoded;
    return payload;
  }
}
